import React, { Component } from 'react';
import TechStack from './TechStack';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

class Project extends Component {
	constructor(props) {
		super(props);
		this.state = {
			item: {}
		};
	}

	componentWillMount() {
		const data = this.props.getItem(this.props.match.params.id);
		this.setState({
			item: data[0]
		});
	}

	handleClick = () => {
		window.history.back();
	};

	render() {
		return (
			<div className="project">
				<button className="project__btn" onClick={this.handleClick}>
					<FontAwesomeIcon icon={['fas', 'chevron-left']} />
				</button>
				<h1 className="project__heading section-heading-primary section-heading-primary--white">
					{this.state.item.name}
				</h1>
				<div className="project__video">
					<video
						width="100%"
						height="auto"
						autoPlay="autoplay"
						loop="loop"
						muted
					>
						<source src={this.state.item.video} />
					</video>
					<div className="project__video-overlay">
						<ul className="icon__list">
							<li className="icon__item">
								<a
									href={this.state.item.githubLink}
									target="_blank"
									className="project__link"
								>
									<FontAwesomeIcon
										icon={['fab', 'github-alt']}
										size="5x"
									/>
									<span className="icon__label">
										Check it out
									</span>
								</a>
							</li>
						</ul>
					</div>
				</div>
				<TechStack stack={this.state.item.stack} />
				<div className="project__description">
					<p className="paragraph">{this.state.item.description}</p>
				</div>
			</div>
		);
	}
}

export default Project;



// WEBPACK FOOTER //
// ./src/components/Project.js